import moment from "moment";
import React, { useEffect, useState } from "react";
import { ReactComponent as UserCircle } from "../assets/icons/user-circle.svg";
import { ReactComponent as StoreIcon } from "../assets/icons/building-02.svg";
import { ReactComponent as ArrowIcon } from "../assets/icons/arrow.svg";
import { ReactComponent as HistoryIcon } from "../assets/icons/history.svg";
import { logger } from "../utils/Utils";
import { requestAuthGet } from "../api/authInstance";
import Container from "../components/Container/Container";
import { useTranslation } from "react-i18next";
import { ScrollShadow } from "@nextui-org/react";
import { Link } from "react-router-dom";

export default function HomeFragment({ userData }) {
  const { t } = useTranslation();

  const [projectData, setProjectData] = useState([]);
  const [showModalLoading, setShowModalLoading] = useState(false);
  useEffect(() => {
    if (userData) {
      getData();
    } else {
      logger("Not Login");
    }
    return () => {};
  }, []);

  async function getData() {
    // show modal loading until data loaded
    setShowModalLoading(true);
    try {
      // get list voucher active
      let res = await requestAuthGet(`project`, {
        params: {
          isActive: true,
          retailer: userData?.outlet?.retailer?.id,
          type: "42f7e8fe-b5de-4843-8506-707e8dc37e7c",
        },
      });
      setProjectData(res.data.data);
    } catch (error) {
      console.error(error);
    }
    // hide modal loading after data is loaded
    setShowModalLoading(false);
  }

  return (
    <>
      {/* <ModalLoading
            showModal={showModalLoading}
            setShowModal={setShowModalLoading}
         /> */}
      <Container>
        <div className="space-y-8">
          <div className="space-y-4">
            <div className="flex justify-between">
              <div className="text-xl font-semibold">
                {t("greetings.welcome")},{" "}
                <span className="bg-gradient-to-r from-blue-600 from-5% via-purple-600 via-50% to-soft-red-500 to-95% bg-clip-text font-semibold text-transparent">
                  {userData?.firstName ?? ""} {userData?.lastName ?? ""}
                </span>
              </div>
            </div>
            <div className="bg-users relative w-full rounded-lg border text-monochrome-0 drop-shadow-lg">
              <div className="px-4 py-5">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3 text-white">
                    <div className="flex items-center justify-center rounded-full bg-transparent-white-20 p-2 drop-shadow-md">
                      <UserCircle className="h-8 w-8" />
                    </div>
                    <div className="space-y-0.5">
                      <p className="font-semibold drop-shadow-md">
                        {userData?.firstName ?? ""} {userData?.lastName ?? ""}
                      </p>
                      <p className="text-monochrome-50 drop-shadow-md">
                        {userData?.role?.roleName ?? ""}
                      </p>
                    </div>
                  </div>
                  <Link to="/profile">
                    <ArrowIcon className="h-7 w-7" />
                  </Link>
                </div>
              </div>
              <div className="rounded-t-lg bg-transparent-white-40 px-4 py-5">
                <div className="flex items-center gap-3 text-white">
                  <div className="flex items-center justify-center rounded-full bg-transparent-white-20 p-2 drop-shadow-md">
                    <StoreIcon className="h-8 w-8" />
                  </div>
                  <div className="space-y-0.5">
                    <p className="font-semibold drop-shadow-md">
                      {userData?.outlet?.name ?? ""}
                    </p>
                    <p className="text-monochrome-50 drop-shadow-md">
                      {userData?.outlet?.address ?? ""}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Link
            to="/transaction"
            className="relative my-2 flex w-full items-center justify-between rounded-md bg-gradient-to-br  from-blue-50 via-purple-50 to-soft-red-50 p-4 text-monochrome-600 drop-shadow-md"
          >
            <div className="flex items-center gap-3">
              <HistoryIcon />{" "}
              <p className="font-semibold">{t("home.transactionHistory")}</p>
            </div>
            <ArrowIcon className="h-7 w-7 text-soft-red-500 " />
          </Link>

          <div className="">
            <h6 className="text-lg font-semibold">{t("home.titlePromo")}</h6>
            <p className="text-transparent-black-60">
              {t("home.subtitlePromo")}
            </p>
            <ScrollShadow
              orientation="horizontal"
              className="my-4 flex max-w-full gap-4 py-3"
              hideScrollBar
            >
              {projectData.map((item, i) => (
                <div
                  key={i}
                  className="min-w-[21rem] rounded-lg border-monochrome-200 bg-white shadow-md"
                >
                  {item.img ? (
                    <img
                      src={item.img}
                      alt={item.alias}
                      className="h-48 w-full rounded-t-lg object-cover"
                    />
                  ) : (
                    <div className="flex h-48 items-center justify-center rounded-t-lg bg-gray-100">
                      {t("home.emptyImage")}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="ml-2 h-6 w-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"
                        />
                      </svg>
                    </div>
                  )}
                  <div className="space-y-2 rounded-b-lg p-4 text-xs">
                    <h6 className="text-base font-semibold">
                      {(item.alias ?? item.name).substring(0, 32)}
                    </h6>
                    {/* <div className="flex justify-between">
                      <p className="text-transparent-black-60">
                        {t("home.remainingDeposit")}
                      </p>
                      <p>
                        Rp.{" "}
                        {item.depositBalance
                          ? item.depositBalance.toLocaleString("id-ID")
                          : 0}
                      </p>
                    </div> */}
                    <div className="flex justify-between">
                      <p className="text-transparent-black-60">
                        {t("home.validUntil")}
                      </p>
                      <p>
                        {moment.utc(item.endDate).local().format("DD/MM/YYYY")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </ScrollShadow>
          </div>
        </div>
      </Container>
    </>
  );
}
